import {
  IQuickVideoForm,
  QuickVideoEmailSmsValues,
} from 'lib/api/quickVideo/types';
import { ButtonPillSwitch } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import { Typography } from 'react-covideo-common';
import { useFormikContext } from 'formik';
import { CustomizeEmailSmsComponent } from '../CustomizeEmailSmsComponent';
import styled, { useTheme } from 'styled-components/macro';

const StyledButtonPillSwitch = styled(ButtonPillSwitch)`
  width: 100%;
  box-sizing: border-box;
`;

export const QuickVideoCustomizeEmailSmsForm = () => {
  const { setFieldValue, values } = useFormikContext<IQuickVideoForm>();
  const theme = useTheme();
  const selectedValue = values.generateEmailSmsContent
    ? QuickVideoEmailSmsValues.GENERATE_WITH_AI
    : QuickVideoEmailSmsValues.CUSTOMIZE_SCRIPT;

  return (
    <Flex gap='20px'>
      <Typography
        color={theme.colors.neutral[80]}
        variant='small'
        fontWeight={600}
      >
        Email / SMS Script
      </Typography>

      <StyledButtonPillSwitch
        defaultValue={selectedValue}
        onChange={value => {
          setFieldValue(
            'generateEmailSmsContent',
            value === QuickVideoEmailSmsValues.GENERATE_WITH_AI ? 1 : 0
          );
        }}
        values={QuickVideoEmailSmsValues}
        pillStyle={{
          width: '49.5%',
        }}
        textStyle={{
          width: '49.8%',
        }}
      />

      <CustomizeEmailSmsComponent />
    </Flex>
  );
};
